import { Effect, Match, type Scope } from "effect";
import { AcceptedWork } from "../state/accepted-work.ts";
import { editorDocumentDependencyFailure, type EditorDocumentHydration, type EditorDocumentIdentity, type EditorFilesUpdate, type EditorFoldersUpdate } from "./documents-model.ts";
import type { EditorDocuments } from "./documents-service.ts";

export type EditorDocumentAction =
  | { readonly tag: "Files"; readonly identity: EditorDocumentIdentity; readonly update: EditorFilesUpdate }
  | { readonly tag: "Folders"; readonly identity: EditorDocumentIdentity; readonly update: EditorFoldersUpdate }
  | { readonly tag: "Hydrate"; readonly input: EditorDocumentHydration; readonly after: () => void };

export const makeEditorDocumentCommand = (documents: typeof EditorDocuments.Service, root: Scope.Scope) =>
  Effect.fn("Frontend.EditorDocuments.command")((action: EditorDocumentAction) => AcceptedWork.use(work => work.join(Effect.gen(function* () {
    return yield* Match.value(action).pipe(
      Match.discriminatorsExhaustive("tag")({
        Files: value => documents.updateFiles(value.identity, value.update).pipe(Effect.asVoid),
        Folders: value => documents.updateFolders(value.identity, value.update).pipe(Effect.asVoid),
        Hydrate: value => Effect.gen(function* () {
          const applied = yield* documents.hydrate(value.input);
          if (applied && root.state._tag !== "Closed") yield* Effect.try({ try: value.after, catch: editorDocumentDependencyFailure });
        })
      })
    );
  }))));
